import { render, staticRenderFns } from "./EvaluationResult.vue?vue&type=template&id=b1827742&scoped=true&"
import script from "./EvaluationResult.vue?vue&type=script&lang=js&"
export * from "./EvaluationResult.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationResult.vue?vue&type=style&index=0&id=b1827742&lang=sass&scoped=true&"
import style1 from "./EvaluationResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1827742",
  null
  
)

export default component.exports